import React from 'react';
import { Link } from 'react-router-dom';
import { useFeatureNav } from '../hooks/useFeatureNav';

/*
 * A link to another platform surface that stays in the panel when it is in
 * one.
 *
 * Drop-in for `Link`: same markup, same href, so a middle-click still opens
 * the page on its own and nothing about the rendered row changes. The only
 * difference is a plain left-click inside a panel, which swaps the panel's
 * body instead of navigating out of the flow the panel is holding.
 */
export const FeatureLink: React.FC<{
  to: string;
  className?: string;
  title?: string;
  children: React.ReactNode;
}> = ({ to, className, title, children }) => {
  const { go, inPanel } = useFeatureNav();

  const onClick = (event: React.MouseEvent) => {
    if (!inPanel) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey) return;
    event.preventDefault();
    go(to);
  };

  return (
    <Link to={to} className={className} title={title} onClick={onClick}>
      {children}
    </Link>
  );
};
